import { useUser as useClerkUser } from '@clerk/clerk-react';

const useUser = () => {
  const { user: clerkUser } = useClerkUser();

  return {
    jwt: {
      id: clerkUser?.id,
      imageUrl: clerkUser?.imageUrl,
      username: clerkUser?.username,
      companyId: clerkUser?.publicMetadata?.companyId,
      email: clerkUser?.primaryEmailAddress?.emailAddress,
      alertEmail: clerkUser?.publicMetadata?.alertEmail,
      emailIsVerified: clerkUser?.primaryEmailAddress?.verification?.status === 'verified',
      name: clerkUser?.fullName,
      admin: clerkUser?.publicMetadata?.isAdmin === true,
      companyChannel: clerkUser?.publicMetadata?.companyChannel,
      role: clerkUser?.publicMetadata?.role,
      roleId: clerkUser?.publicMetadata?.roleId,
      permissions: clerkUser?.publicMetadata?.permissions,
      adminChannel: clerkUser?.publicMetadata?.adminChannel,
      userChannel: clerkUser?.publicMetadata?.userChannel,
      completedTutorials: clerkUser?.publicMetadata?.completedTutorials || [],
      twoFactorEnabled: clerkUser?.twoFactorEnabled,
      quickStartProgress: clerkUser?.unsafeMetadata?.quickStartProgress || {},
      embeddedProgress: clerkUser?.unsafeMetadata?.embeddedProgress || {}
    },
    settings: {
      name: clerkUser?.fullName,
      email: clerkUser?.primaryEmailAddress?.emailAddress,
      alertEmail: clerkUser?.publicMetadata?.alertEmail,
      alerts: {
        operationsExceeded: clerkUser?.publicMetadata?.alerts?.operationsExceeded ?? true,
        operationsExceededThreshold: clerkUser?.publicMetadata?.alerts?.operationsExceededThreshold ?? 90
      }
    }
  };
};

export default useUser;
